<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{$t('pageLeads.view.title')}} : <span v-if="item">{{ item.fio }}</span>
        </h1>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>
    <span @click="$router.push({ name: 'LeadList' })" class="goback"
      >{{$t('pageLeads.list.goBack')}}</span
    >

    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 pt-0>
            <loading v-if="loading" />
            <div class="block grid-list-lg" v-else>
              <div v-if="errors">
                <h2 class="empty_title" v-if="errors && errors.length">
                  <v-icon color="error">warning</v-icon>
                  {{$t('pageLeads.view.errorLoading')}} : {{ errors }}
                </h2>
              </div>
              <div v-else>
                <div v-if="item">
                  <table class="table-noborder">
                    <tbody>
                      <tr>
                        <td>{{$t('pageLeads.list.table.fields.fio')}}</td>
                        <td>
                          {{ item.fio }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{$t('pageLeads.list.table.fields.phone')}}</td>
                        <td>
                          {{ item.phone | formatPhone }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{$t('pageLeads.list.table.fields.region')}}</td>
                        <td>
                          {{ item.region }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{$t('pageLeads.list.table.fields.created_at')}}</td>
                        <td>
                          {{ item.created_at | formatDate }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{$t('pageLeads.list.table.fields.timezone')}}</td>
                        <td>
                          {{ item.timezone }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{$t('pageLeads.list.table.fields.wait_type')}}</td>
                        <td>
                          {{ item.wait_type }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{$t('pageLeads.list.table.fields.status')}}</td>
                        <td>
                          <v-chip
                            label
                            :text-color="getStatus(item.status, 'text')"
                            :color="getStatus(item.status, 'color')"
                          >
                            {{ getStatus(item.status, "name") }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout v-if="isShowActionPanel">
          <v-flex xs12 pt-0>
            <div class="block">
              <v-flex xs12 py-0 mb-5>
                <v-flex xs12 py-0 mb-5>
                  <v-divider />
                </v-flex>
                <v-flex xs12 py-0>
                  <!-- <v-btn
                    class="mr-2"
                    :loading="loading"
                    :disabled="loading"
                    color="green"
                    dark
                    x-large
                    @click="openVerifieldModal()"
                    >{{$t('pageLeads.view.actions.verified')}}</v-btn
                  >

                  <v-btn
                    class="mr-2"
                    color="deep orange"
                    dark
                    x-large
                    :loading="loading"
                    :disabled="loading"
                    @click="openNotVerifieldModal()"
                    >{{$t('pageLeads.view.actions.noVerified')}}</v-btn
                  > -->

                  <v-btn
                    color="red"
                    dark
                    x-large
                    @click="openBlockModal()"
                    :loading="loading"
                    :disabled="loading"
                    >{{$t('pageLeads.view.actions.decline')}}</v-btn
                  >
                </v-flex>

                <v-flex xs12 py-0 my-5>
                  <v-divider />
                </v-flex>
              </v-flex>
            </div>
          </v-flex>
        </v-layout>

        <!--leadsHistory-->
        <v-layout row wrap v-if="item && item.leadsHistory">
          <v-flex xs12 pt-0>
            <div v-if="item" class="block">
              <h2>{{ $t('pageLeads.view.history.title') }}</h2>
              <table class="table-noborder">
                <tbody>
                  <tr v-for="history in item.leadsHistory" :key="history.id">
                    <td class="nowrap">
                      <v-chip label color="gray">{{history.created_at | formatDate}}</v-chip>
                    </td>
                    <td class="w100">
                      {{ history.value.text }}
                      <span v-if="history.value.comment" class="caption">{{history.value.comment}}</span>
                    </td>
                    <td class="nowrap">
                      {{ history.user.full_name }}
                    </td>
                    <td>
                      <v-chip
                        v-if="history.status"
                        label
                        :text-color="getStatus(history.status, 'text')"
                        :color="getStatus(history.status, 'color')"
                      >
                        {{ getStatus(history.status, "name") }}
                      </v-chip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="commentModal.show" max-width="600px" persistent>
      <v-layout row wrap modal__block>
        <span class="modal__close" @click="closeBlockModal"></span>
        <v-flex xs12 modal__wrapper pt-10 style="min-height: 400px">
          <v-flex shrink>
            <v-textarea
              v-model="commentModal.comment"
              outlined
              :label="$t('pageLeads.view.declineModal.label')"
              pl2aceholder="$t('pageLeads.view.declineModal.placeholder')"
              class="show-modal-comment pa-2"
            ></v-textarea>
          </v-flex>
          <v-btn
            class="mt-5"
            :loading="commentModal.loading"
            @click="onChangeStatus"
            :disabled="!commentModal.comment"
            x-large
            style="color: white"
            color="red"
            >{{$t('pageLeads.view.declineModal.submit')}}</v-btn
          >
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import showNotify from "@/services/noty";
import formatDateTime from "@/mixins/filters/formatDateTime";
import formatDate from "@/mixins/filters/formatDate";
import formatPhone from "@/mixins/filters/formatPhone";
import statusNames from "@/utils/data/statuses";

export default {
  name: "ViewLead",
  mixins: [formatDateTime, formatDate, formatPhone],
  data: () => ({
    errors: null,
    id: "",
    chat_id: "",
    loading: true,
    item: null,
    statusNames,

    commentModal: {
      show: false,
      comment: null,
      status: null,
      loading: false,
    },
  }),
  methods: {
    async onChangeStatus() {
      this.commentModal.loading = true;
      this.errors = null;
      await apiCallTrue({
        url: `v1/leads/${this.chat_id}/${this.id}/change-status`,
        method: "POST",
        data: {
          comment: this.commentModal.comment,
          status: this.commentModal.status,
        },
      })
        .then((response) => {
          console.log("RESP", response);
          this.closeBlockModal();
         // this.getLead();
        })
        .catch((error) => {
          showNotify("error", error);
          this.errors = error.message;
        })
        .finally(() => {
          this.commentModal.loading = false;
        });
    },
    __clearModalVariable() {
      this.commentModal.status = null;
      this.commentModal.comment = null;
      this.commentModal.loading = false;
    },
    closeBlockModal() {
      this.commentModal.show = false;
      this.__clearModalVariable();
    },
    openBlockModal() {
      this.__clearModalVariable();
      this.commentModal.show = true;
      this.commentModal.status = 5;
    },
    getStatus(id, param) {
      return this.statusNames["leads"][id][param]
        ? this.statusNames["leads"][id][param]
        : "";
    },
    async getLead() {
      this.item = null;
      this.loading = true;
      this.errors = null;
      await apiCallTrue({
        url: `v1/leads/${this.chat_id}/${this.id}`,
      })
        .then((response) => {
          this.item = response.data.data;
        })
        .catch((error) => {
          showNotify("error", error);
          this.errors = error.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getSocketMessage(message) {
      console.log("view lead MESSSAGE", message);
      switch (message.type) {
        case 2:
          if (
            message.action === "updateLead" &&
            parseInt(message.data) === this.id
          ) {
            console.log("UPDATE WS VIEW LEAD", this.id);
            this.getLead();
          }
          break;
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.chat_id = this.$route.params.chat_id;
    this.getLead();
  },
  components: {},
  watch: {
    wSocket(message) {
      this.getSocketMessage(message);
    },
  },
  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
      wSocket: (state) => state.wSocket.message,
    }),

    isShowActionPanel() {
      if (!this.item) return false;
      if (this.item.status == 2) return false;
      if (this.item.status == 5) return false;
      return true;
    },
  },
};
</script>
<style lang="scss">
</style>